<div class="row height-100 m-0">
  <div class="col-12 col-sm-5 p-0">
    <lib-prod-header [title]="'Site'">
      <lib-prod-form [fields]="fields"
                     [data]="dialogData.data"
                     (onSubmitEvent)="submit($event)"></lib-prod-form>
    </lib-prod-header>
  </div>
  <div class="col-12 col-sm-7 p-0">
    <lib-prod-header [title]="'map'">
      <lib-prod-map
        [mapName]="mapName"
        [showAddressSearchField]="true"
        [isMarkersDraggable]="true"
        [markers$]="markers$"
        (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
    </lib-prod-header>
  </div>
</div>
